export default __webpack_public_path__ + "static/lizThoughtDining-d46ea3b2388a0bae8fccde8401e64d0b.svg";